import {OptionalSelectedItemsData} from "../../../components/EntitySelector/EntitySelector.types";
import {Exhibit} from "../../../types/Exhibit";
import {Facility} from "../../../types/Facility";
import {TrailWaypoint} from "../../../types/TrailWaypoint";

export function createSelectedWaypointEntities(waypoint: TrailWaypoint | null): OptionalSelectedItemsData {
  if (!waypoint || !waypoint.exhibits || !waypoint.facilities) return {};

  const exhibits = waypoint.exhibits.map(exhibit => ({
    id: exhibit.id,
    name: exhibit.name,
    image: exhibit.image,
    zone: exhibit.zone
  })) as Exhibit[];

  const facilities = waypoint.facilities.map(facility => ({
    id: facility.id,
    name: facility.name,
    image: facility.image,
    zone: facility.zone
  })) as Facility[];

  return {
    'exhibit': exhibits,
    'facility': facilities,
  }
}